module.exports = __webpack_public_path__ + "img/boho_rio_gift_heart.52b0d0f4.svg";